// src/packages/dhipaya/motor/dhipaya_car_shortterm_180d/DhipayaShort180Card.jsx
import React from "react";
import "./dhipaya_short180.css";

export default function DhipayaShort180Card({ onSelect }) {
  return (
    <div className="pkg-card dpy-short180">
      <div className="pkg-body">
        <h3>ทิพย 2+ / 3+ — 180 วัน</h3>
        <p>คุ้มครองครึ่งปีสำหรับรถใช้งานส่วนบุคคล • วงเงินหลักตามแผน</p>
        <ul className="pkg-list">
          <li>เลือก 2+ (รวมหาย/ไฟไหม้) หรือ 3+ (ชนกับยานพาหนะทางบก)</li>
          <li>ความรับผิดต่อบุคคลภายนอกตามเงื่อนไข</li>
          <li>แนบท้าย PA/MA/DR ให้ความคุ้มครองผู้ขับ/ผู้โดยสาร</li>
        </ul>
        <button className="pkg-btn" onClick={onSelect}>ดูรายละเอียด</button>
      </div>
    </div>
  );
}
